import { useSelector } from 'react-redux';

import { SearchQuery } from 'modules/domains';

import { selectCombinator, selectSearchGroups } from '../../selectors';

export const useRootQuery = (): SearchQuery => {
  const combinator = useSelector(selectCombinator);
  const searchQueries = useSelector(selectSearchGroups);
  return { combinator, searchQueries };
};
